import React from "react";
import "./Utils.css";

function Utils() {
  return (
    <div className="utils-container">
      <h1>Applets Utils Instructions</h1>
      <p>
        The Satochip Utils application is your one-stop solution to manage your
        Satochip cards, including Satodime and Seedkeeper. It allows you to
        change your PIN code, reset your card, set up your hardware wallet, and
        much more.
      </p>

      <h2>Getting Started</h2>
      <ol>
        <li>
          Clone the{" "}
          <a
            href="https://github.com/Toporin/Satochip-Utils"
            target="_blank"
            rel="noopener noreferrer"
            className="utils-link"
          >
            Satochip Utils repository
          </a>
          :
          <div className="code-block">
            <code>git clone git@github.com:Toporin/Satochip-Utils.git</code>
          </div>
        </li>
        <li>
          Navigate to the repository directory:
          <div className="code-block">
            <code>cd Satochip-Utils</code>
          </div>
        </li>
        <li>
          Optional: Create and activate a virtual environment:
          <div className="code-block">
            <div>
              <code># Create the virtual environment</code>
            </div>
            <div>
              <code>python3 -m venv venv</code>
            </div>
            <div style={{ marginTop: "10px" }}>
              <code># Activate the virtual environment (Linux/Mac)</code>
            </div>
            <div>
              <code>source venv/bin/activate</code>
            </div>
            <div style={{ marginTop: "10px" }}>
              <code>
                # Activate the virtual environment (Windows Command Prompt)
              </code>
            </div>
            <div>
              <code>venv\Scripts\activate</code>
            </div>
          </div>
        </li>
        <li>
          Install the required Python dependencies:
          <div className="code-block">
            <code>python3 -m pip install -r requirements.txt</code>
          </div>
        </li>
        <li>
          Run the Satochip Utils application:
          <div className="code-block">
            <code>python3 satochip_utils.py</code>
          </div>
        </li>
      </ol>

      <h2>Features</h2>
      <p>With Satochip Utils, you can:</p>
      <ul>
        <li>Set or change the PIN code (4-16 characters).</li>
        <li>Set or edit the label for your card.</li>
        <li>Check the authenticity of your card.</li>
        <li>
          Factory reset your card to erase all private keys and saved data.
        </li>
        <li>Seed your Satochip or Seedkeeper hardware wallet.</li>
      </ul>

      <p>
        For more information, refer to the{" "}
        <a
          href="https://github.com/Toporin/Satochip-Utils"
          target="_blank"
          rel="noopener noreferrer"
          className="utils-link"
        >
          official Satochip Utils documentation
        </a>
        .
      </p>

      <h2>Factory Reset</h2>
      <p>
        The factory reset feature allows you to reset your Satochip or
        Seedkeeper card to its factory state. This will erase all private keys,
        PIN codes, labels, and other stored data. Ensure you have backed up your
        data before performing this action.
      </p>
      <ul>
        <li>Plug in your card and launch the Satochip Utils tool.</li>
        <li>Click on "Reset my card".</li>
        <li>Follow the wizard to complete the reset process.</li>
      </ul>
    </div>
  );
}

export default Utils;
